export default "__VITE_ASSET__CYJsDLaR__"